/*global GetAppInfo */
/*eslint no-undef: "error"*/

export const redirectToApp = (APP, sessionGUID, openNewTab=true) => {
  const app = GetAppInfo(APP);
  const url = `${app.siteURL}/${app.mainPage}?S=${sessionGUID}`;
  if (openNewTab) {
    window.open(url, '_blank');
  } else {
    window.location = url;
  }
}


// WEBPACK FOOTER //
// ./src/utilities/redirect.js